import React from "react"

function TextError({ children }) {
    return (
        <div style={{color: 'red'}}>
            {children}
        </div>
    )
};

export default TextError;